<h3 class="fee-basis-table-header">{{ identifier }}</h3>
<table mat-table matSort matSortActive="date" matSortDirection="desc" matSortDisableClear [dataSource]="dataSource" class="mat-elevation-z2">
    <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Dato </th>
        <td mat-cell *matCellDef="let element"> {{$safeNavigationMigration(element?.date) | date:'dd/MM/yyyy'}} </td>
        <td mat-footer-cell *matFooterCellDef><b>Total</b></td>
    </ng-container>
    <ng-container matColumnDef="invoiceNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fakt.nr </th>
        <td mat-cell *matCellDef="let element"> {{element?.invoiceNumber}} </td>
        <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>
    <ng-container matColumnDef="taskNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Opgave ID </th>
        <td mat-cell *matCellDef="let element"> {{element?.taskNumber}} </td>
        <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>
    <ng-container matColumnDef="consultantInitials">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Konsulent </th>
        <td mat-cell *matCellDef="let element"> {{element?.consultantInitials}} </td>
        <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>
    <ng-container matColumnDef="customer">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Kunde </th>
        <td mat-cell *matCellDef="let element"> {{element?.customer}} </td>
        <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>
    <ng-container matColumnDef="leadCreator">
        <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" class="right-align"> Lead Creator </th>
        <td mat-cell *matCellDef="let element" class="right-align"> {{$safeNavigationMigration(element?.leadCreator) | number:'1.0-0':'da'}} </td>
        <td mat-footer-cell *matFooterCellDef class="right-align">{{$safeNavigationMigration(totals?.leadCreator) | number: '1.0-0':'da'}}</td>
    </ng-container>
    <ng-container matColumnDef="salesRealizator">
        <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" class="right-align"> Salgsrealisator </th>
        <td mat-cell *matCellDef="let element" class="right-align"> {{$safeNavigationMigration(element?.salesRealizator) | number:'1.0-0':'da'}} </td>
        <td mat-footer-cell *matFooterCellDef class="right-align">{{$safeNavigationMigration(totals?.salesRealizator) | number: '1.0-0':'da'}}</td>
    </ng-container>
    <ng-container matColumnDef="executor">
        <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" class="right-align"> Udførende </th>
        <td mat-cell *matCellDef="let element" class="right-align"> {{$safeNavigationMigration(element?.executor) | number:'1.0-0':'da'}} </td>
        <td mat-footer-cell *matFooterCellDef class="right-align">{{$safeNavigationMigration(totals?.executor) | number: '1.0-0':'da'}}</td>
    </ng-container>
    <ng-container matColumnDef="sum">
        <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" class="right-align"> Sum </th>
        <td mat-cell *matCellDef="let element" class="right-align"> {{$safeNavigationMigration(element?.sum) | number:'1.0-0':'da'}}</td>
        <td mat-footer-cell *matFooterCellDef class="right-align">{{$safeNavigationMigration(totals?.sum) | number: '1.0-0':'da'}}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns" class="header-row"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns; when: isDataRow" [class.singleton-divider]="row.isSingletonGroup" [class.singleton-invoice]="row.isSingletonGroup && mode === 'opgave'"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns; when: isSubtotalRow" class="subtotal-row"></tr>
    <tr mat-footer-row class="footer-row" *matFooterRowDef="displayedColumns;sticky:true"></tr>
</table>
